export enum HomeAnalyticsEnum {
  VIEW_HOME_WITHOUT_LOCATION = '[PAC WEB] Home - Sem Localização - Página visualizada',
  VIEW_HOME_LOCATION = '[PAC WEB] Home - Cidade - Página visualizada',

  VIEW_SEARCH_MODAL_DEFAULT = '[PAC WEB] Home - Modal de busca exibida',
  VIEW_SEARCH_ADD_MORE_EXAMES_OR_KEEP_EXAMS = '[PAC WEB] Home - Modal decisão - Adicionar mais ou manter um exame',
  VIEW_SEARCH_SELECT_MORE_EXAMES = '[PAC WEB] Home - Modal de seleção de mais exames',
  VIEW_ATTENTION_TO_LOSE_LABORATORY_PROCEDURE = '[PAC WEB] Home - Modal de alerta de perda de exames selecionados',
  VIEW_SELECTED_OVERVIEW_EXAMS = '[PAC WEB] Home - Modal de resumo dos exames selecionados',

  CLICK_CLEAR_LAST_SEARCHES = '[PAC WEB] Home - Modal de busca - Clicou em "Limpar últimas buscas"',
  CLICK_LAST_SEARCHED_ITEM = '[PAC WEB] Home - Modal de busca - Clicou em "Item das últimas buscas"',
  SHOW_MORE_RESULTS_PROCEDURES_MODAL = '[PAC WEB] Modal de busca - Carregou mais resultados',
  CLICK_CLEAR_FILTERS_SEARCH_MODAL = '[PAC WEB] Modal de busca - Clicou em "Limpar busca"',
  CLICK_RESULT_SEARCH_MODAL = '[PAC WEB] Modal de busca - Clicou em resultado da busca',

  SEARCHED_PROCEDURES_MODAL_WITH_RESULTS = '[PAC WEB] Modal de busca - Busca realizada com resultado',
  SEARCHED_PROCEDURES_MODAL_WITHOUT_RESULTS = '[PAC WEB] Modal de busca - Busca realizada sem resultado',

  CLICK_BANNER = '[PAC WEB] Home - Cidade - Clicou no banner',
  CLICK_LEAD_PRESENTIAL_SERVICE = '[PAC WEB] Home - Cidade - Leads - Atendimento presencial',
  CLICK_INSTALL_APP = '[PAC WEB] Home - Cidade - Clicou em "Instalar aplicativo"',
  CLICK_INFORM_LOCATION = '[PAC WEB] Home - Cidade - Clicou em "Informar localização"',

  CLICK_SCHEDULE_NOW_HOME_PAGE = '[PAC WEB] Home - Cidade - Clicou em "Agendar agora"',

  CLICK_MOST_SEARCHED_CATEGORY = '[PAC WEB] Home - Cidade - Mais procurados - Clicou na categoria',
  CLICK_MOST_SEARCHED_PROCEDURE = '[PAC WEB] Home - Cidade - Mais procurados - Clicou no procedimento',
  CLICK_MOST_SEARCHED_SEE_MORE = '[PAC WEB] Home - Cidade - Mais procurados - Clicou em "Ver mais"',

  CLICK_CITY_BUTTON_SCHEDULE_BY_WEBSITE = '[PAC WEB] Home - Cidade - Clicou em "Agendar pelo site"',
  CLICK_CITY_BUTTON_SCHEDULE_SUPPORT = '[PAC WEB] Home - Cidade - Clicou em "Agendar com atendente"',
  CLICK_CITY_BUTTON_TELEHEALTH = '[PAC WEB] Home - Cidade - Clicou em "Agendar teleconsulta"',

  VIEW_BRANCH_HOME = '[PAC WEB] Home - Unidade Física - Página visualizada',
  CLICK_CITY_BUTTON_SCHEDULE_BRANCH = '[PAC WEB] Home - Unidade Física - Clicou em "Agendar com atendente"',
  CLICK_SCHEDULE_APPOINTMENTS_BRANCH = '[PAC WEB] Home - Unidade Física - Clicou em "Agendar consultas"',
  CLICK_SCHEDULE_EXAMS_BRANCH = '[PAC WEB] Home - Unidade Física - Clicou em "Agendar exames"',
  CLICK_SEND_MESSAGE_BRANCH = '[PAC WEB] Home - Unidade Física - Clicou em "Enviar mensagem"',
  CLICK_OPEN_MAP_BRANCH = '[PAC WEB] Home - Unidade Física - Clicou em "Abrir no mapa"',
  CLICK_SOCIAL_MEDIA_BRANCH = '[PAC WEB] Home - Unidade Física - Rede Social - Clicou',
}
